import { render, staticRenderFns } from "./MyReviews.vue?vue&type=template&id=34e0e50d&scoped=true"
import script from "./MyReviews.vue?vue&type=script&lang=js"
export * from "./MyReviews.vue?vue&type=script&lang=js"
import style0 from "./MyReviews.vue?vue&type=style&index=0&id=34e0e50d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e0e50d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e0e50d')) {
      api.createRecord('34e0e50d', component.options)
    } else {
      api.reload('34e0e50d', component.options)
    }
    module.hot.accept("./MyReviews.vue?vue&type=template&id=34e0e50d&scoped=true", function () {
      api.rerender('34e0e50d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/MyReviews.vue"
export default component.exports